import HTTP from "../http";
import freshdeskScheduleHelper from "../helpers/freshdesk/reschedule";
import freshdeskCancellationHelper from "../helpers/freshdesk/cancellation";

async function send(data) {
  try {
    await HTTP.freshdesk.post("", data);
  } catch (e) {
    throw "Ocorreu um erro ao enviar o ticket!";
  }
}

async function rescheduleTicket(payload) {
  let data = freshdeskScheduleHelper.createRescheduleBody(payload);

  try {
    await send(data);
  } catch (e) {
    throw e;
  }
}

async function cancellationTicket(payload, absence) {
  let data = freshdeskCancellationHelper.createCancellationBody(
    payload,
    absence
  );

  try {
    await send(data);
  } catch (e) {
    throw e;
  }
}

async function creditHoursTicket(payload, absence) {
  let data = freshdeskCancellationHelper.createCreditHoursBody(
    payload,
    absence
  );

  try {
    await send(data);
  } catch (e) {
    throw e;
  }
}

export default {
  rescheduleTicket,
  creditHoursTicket,
  cancellationTicket
};



// WEBPACK FOOTER //
// ./src/api/outers/freshdesk.js